[
  {
    "num": "1",
    "x": "275",
    "y": "330",
    "x2": "335",
    "y2": "480",
    "x3": "318",
    "y3": "560",
    "curve": "0.75",
    "club": "Preston North End",
    "fixture": "Preston North End v Fulham",
    "season": "1994/95"
  },
  {
    "num": "2",
    "x": "398",
    "y": "355",
    "x2": "430",
    "y2": "505",
    "x3": "370",
    "y3": "570",
    "curve": "0.25",
    "club": "Manchester United",
    "fixture": "Manchester United v Southampton",
    "season": "1996/97"
  },
  {
    "num": "3",
    "x": "280",
    "y": "320",
    "x2": "335",
    "y2": "480",
    "x3": "318",
    "y3": "560",
    "curve": "0.85",
    "club": "Manchester United",
    "fixture": "Manchester United v Tottenham",
    "season": "1996/97"
  },
  {
    "num": "4",
    "x": "417",
    "y": "350",
    "x2": "400",
    "y2": "480",
    "x3": "318",
    "y3": "570",
    "curve": "0.85",
    "club": "Manchester United",
    "fixture": "Manchester United v Liverpool",
    "season": "1997/98"
  },
  {
    "num": "5",
    "x": "425",
    "y": "240",
    "x2": "450",
    "y2": "457",
    "x3": "380",
    "y3": "550",
    "curve": "0.85",
    "club": "Manchester United",
    "fixture": "Manchester United v Chelsea",
    "season": "1997/98"
  },
  {
    "num": "6",
    "x": "310",
    "y": "280",
    "x2": "350",
    "y2": "457",
    "x3": "320",
    "y3": "560",
    "curve": "0.85",
    "club": "England",
    "fixture": "England v Colombia",
    "season": "1997/98"
  },
  {
    "num": "7",
    "x": "280",
    "y": "275",
    "x2": "340",
    "y2": "457",
    "x3": "325",
    "y3": "550",
    "curve": "0.85",
    "club": "Manchester United",
    "fixture": "Manchester United v Leicester City",
    "season": "1998/99"
  },
  {
    "num": "8",
    "x": "310",
    "y": "305",
    "x2": "360",
    "y2": "457",
    "x3": "318",
    "y3": "565",
    "curve": "0.85",
    "club": "Manchester United",
    "fixture": "Manchester United v Barcelona",
    "season": "1998/99"
  },
  {
    "num": "9",
    "x": "170",
    "y": "260",
    "x2": "320",
    "y2": "457",
    "x3": "318",
    "y3": "550",
    "curve": "0.85",
    "club": "Manchester United",
    "fixture": "Man Ud v Brondby",
    "season": "1998/99"
  },
  {
    "num": "10",
    "x": "365",
    "y": "315",
    "x2": "380",
    "y2": "457",
    "x3": "370",
    "y3": "562",
    "curve": "1.5",
    "club": "Manchester United",
    "fixture": "Manchester United v Everton",
    "season": "1998/99"
  },
  {
    "num": "11",
    "x": "420",
    "y": "290",
    "x2": "420",
    "y2": "457",
    "x3": "315",
    "y3": "565",
    "curve": "0.85",
    "club": "Manchester United",
    "fixture": "Manchester United v Aston Villa",
    "season": "1998/99"
  },
  {
    "num": "12",
    "x": "170",
    "y": "355",
    "x2": "400",
    "y2": "457",
    "x3": "375",
    "y3": "550",
    "curve": "0.65",
    "club": "Manchester United",
    "fixture": "Manchester United v Dinamo Zagreb",
    "season": "1999/00"
  },
  {
    "num": "13",
    "x": "250",
    "y": "315",
    "x2": "350",
    "y2": "457",
    "x3": "318",
    "y3": "550",
    "curve": "0.65",
    "club": "Manchester United",
    "fixture": "Leicester City v Manchester United",
    "season": "1999/00"
  },
  {
    "num": "14",
    "x": "340",
    "y": "285",
    "x2": "375",
    "y2": "457",
    "x3": "330",
    "y3": "570",
    "curve": "0.65",
    "club": "Manchester United",
    "fixture": "Manchester United v West Ham",
    "season": "1999/00"
  },
  {
    "num": "15",
    "x": "310",
    "y": "335",
    "x2": "385",
    "y2": "457",
    "x3": "375",
    "y3": "560",
    "curve": "0.65",
    "club": "Manchester United",
    "fixture": "Southampton v Manchester United",
    "season": "1999/00"
  },
  {
    "num": "16",
    "x": "120",
    "y": "255",
    "x2": "385",
    "y2": "457",
    "x3": "375",
    "y3": "560",
    "curve": "0.65",
    "club": "Manchester United",
    "fixture": "Ipswich Town v Manchester United",
    "season": "2000/01"
  },
  {
    "num": "17",
    "x": "415",
    "y": "265",
    "x2": "450",
    "y2": "457",
    "x3": "375",
    "y3": "560",
    "curve": "0.85",
    "club": "Manchester United",
    "fixture": "West Ham v Manchester United",
    "season": "2000/01"
  },
  {
    "num": "18",
    "x": "390",
    "y": "343",
    "x2": "380",
    "y2": "500",
    "x3": "360",
    "y3": "550",
    "curve": "0.85",
    "club": "Manchester United",
    "fixture": "Manchester United v Leeds Utd",
    "season": "2000/01"
  },
  {
    "num": "19",
    "x": "320",
    "y": "310",
    "x2": "340",
    "y2": "450",
    "x3": "330",
    "y3": "550",
    "curve": "0.85",
    "club": "Manchester United",
    "fixture": "Coventry City v Manchester United",
    "season": "2000/01"
  },
  {
    "num": "20",
    "x": "370",
    "y": "260",
    "x2": "370",
    "y2": "450",
    "x3": "318",
    "y3": "560",
    "curve": "0.85",
    "club": "Manchester United",
    "fixture": "Man City v Manchester United",
    "season": "2000/01"
  },
  {
    "num": "21",
    "x": "287",
    "y": "310",
    "x2": "370",
    "y2": "450",
    "x3": "325",
    "y3": "560",
    "curve": "0.85",
    "club": "England",
    "fixture": "England v Mexico",
    "season": "2000/01"
  },
  {
    "num": "22",
    "x": "450",
    "y": "324",
    "x2": "450",
    "y2": "450",
    "x3": "375",
    "y3": "560",
    "curve": "0.85",
    "club": "England",
    "fixture": "Greece v England",
    "season": "2000/01"
  },
  {
    "num": "23",
    "x": "255",
    "y": "325",
    "x2": "350",
    "y2": "450",
    "x3": "322",
    "y3": "570",
    "curve": "0.85",
    "club": "Manchester United",
    "fixture": "Manchester United v Fulham",
    "season": "2001/02"
  },
  {
    "num": "24",
    "x": "355",
    "y": "242",
    "x2": "370",
    "y2": "450",
    "x3": "370",
    "y3": "550",
    "curve": "0.85",
    "club": "Manchester United",
    "fixture": "Blackburn Rovers v Manchester United",
    "season": "2001/02"
  },
  {
    "num": "25",
    "x": "345",
    "y": "302",
    "x2": "370",
    "y2": "450",
    "x3": "322",
    "y3": "565",
    "curve": "0.85",
    "club": "England",
    "fixture": "England v Greece",
    "season": "2001/02"
  },
  {
    "num": "26",
    "x": "400",
    "y": "321",
    "x2": "370",
    "y2": "450",
    "x3": "319",
    "y3": "555",
    "curve": "0.85",
    "club": "Manchester United",
    "fixture": "Southampton v Manchester United",
    "season": "2001/02"
  },
  {
    "num": "27",
    "x": "325",
    "y": "370",
    "x2": "360",
    "y2": "450",
    "x3": "380",
    "y3": "555",
    "curve": "0.85",
    "club": "Manchester United",
    "fixture": "Manchester United v Sunderland",
    "season": "2001/02"
  },
  {
    "num": "28",
    "x": "260",
    "y": "285",
    "x2": "340",
    "y2": "470",
    "x3": "320",
    "y3": "565",
    "curve": "0.85",
    "club": "Manchester United",
    "fixture": "Manchester United v Nantes",
    "season": "2001/02"
  },
  {
    "num": "29",
    "x": "395",
    "y": "295",
    "x2": "415",
    "y2": "450",
    "x3": "380",
    "y3": "565",
    "curve": "0.85",
    "club": "Manchester United",
    "fixture": "Manchester United v Zalaegerszeg",
    "season": "2002/03"
  },
  {
    "num": "30",
    "x": "145",
    "y": "224",
    "x2": "435",
    "y2": "425",
    "x3": "380",
    "y3": "550",
    "curve": "0.5",
    "club": "England",
    "fixture": "Slovakia v England",
    "season": "2002/03"
  },
  {
    "num": "31",
    "x": "497",
    "y": "317",
    "x2": "475",
    "y2": "495",
    "x3": "320",
    "y3": "568",
    "curve": "0.75",
    "club": "Manchester United",
    "fixture": "Manchester United v Portsmouth",
    "season": "2002/03"
  },
  {
    "num": "32",
    "x": "370",
    "y": "295",
    "x2": "425",
    "y2": "475",
    "x3": "385",
    "y3": "560",
    "curve": "0.5",
    "club": "England",
    "fixture": "Liechtenstein v England",
    "season": "2002/03"
  },
  {
    "num": "33",
    "x": "443",
    "y": "317",
    "x2": "485",
    "y2": "495",
    "x3": "370",
    "y3": "570",
    "curve": "0.5",
    "club": "Manchester United",
    "fixture": "Manchester United v Real Madrid",
    "season": "2002/03"
  },
  {
    "num": "34",
    "x": "520",
    "y": "337",
    "x2": "470",
    "y2": "515",
    "x3": "320",
    "y3": "565",
    "curve": "0.85",
    "club": "Manchester United",
    "fixture": "Everton v Manchester United",
    "season": "2002/03"
  },
  {
    "num": "35",
    "x": "480",
    "y": "310",
    "x2": "450",
    "y2": "515",
    "x3": "320",
    "y3": "555",
    "curve": "0.75",
    "club": "Real Madrid",
    "fixture": "Malaga v Real Madrid",
    "season": "2003/04"
  },
  {
    "num": "36",
    "x": "330",
    "y": "315",
    "x2": "405",
    "y2": "515",
    "x3": "372",
    "y3": "562",
    "curve": "0.85",
    "club": "Real Madrid",
    "fixture": "Marseille v Real Madrid",
    "season": "2003/04"
  },
  {
    "num": "37",
    "x": "190",
    "y": "275",
    "x2": "350",
    "y2": "515",
    "x3": "322",
    "y3": "550",
    "curve": "0.45",
    "club": "Real Madrid",
    "fixture": "Leganes v Real Madrid",
    "season": "2003/04"
  },
  {
    "num": "38",
    "x": "280",
    "y": "265",
    "x2": "350",
    "y2": "485",
    "x3": "322",
    "y3": "560",
    "curve": "0.85",
    "club": "Real Madrid",
    "fixture": "Real Madrid v Real Zaragoza",
    "season": "2003/04"
  },
  {
    "num": "39",
    "x": "335",
    "y": "295",
    "x2": "400",
    "y2": "485",
    "x3": "322",
    "y3": "560",
    "curve": "0.85",
    "club": "Real Madrid",
    "fixture": "Real Madrid v Numancia",
    "season": "2004/05"
  },
  {
    "num": "40",
    "x": "325",
    "y": "265",
    "x2": "400",
    "y2": "430",
    "x3": "320",
    "y3": "555",
    "curve": "0.55",
    "club": "Real Madrid",
    "fixture": "Real Madrid v Osasuna",
    "season": "2004/05"
  },
  {
    "num": "41",
    "x": "460",
    "y": "295",
    "x2": "450",
    "y2": "500",
    "x3": "325",
    "y3": "568",
    "curve": "0.55",
    "club": "Real Madrid",
    "fixture": "Numancia v Real Madrid",
    "season": "2004/05"
  },
  {
    "num": "42",
    "x": "420",
    "y": "276",
    "x2": "450",
    "y2": "500",
    "x3": "370",
    "y3": "560",
    "curve": "0.55",
    "club": "Real Madrid",
    "fixture": "Real Madrid v Rosenborg",
    "season": "2005/06"
  },
  {
    "num": "43",
    "x": "420",
    "y": "365",
    "x2": "450",
    "y2": "450",
    "x3": "375",
    "y3": "565",
    "curve": "0.55",
    "club": "Real Madrid",
    "fixture": "Real Madrid v Cadiz",
    "season": "2005/06"
  },
  {
    "num": "44",
    "x": "303",
    "y": "202",
    "x2": "400",
    "y2": "450",
    "x3": "375",
    "y3": "550",
    "curve": "0.55",
    "club": "Real Madrid",
    "fixture": "Sevilla v Real Madrid",
    "season": "2005/06"
  },
  {
    "num": "45",
    "x": "175",
    "y": "310",
    "x2": "300",
    "y2": "450",
    "x3": "322",
    "y3": "550",
    "curve": "0.55",
    "club": "England",
    "fixture": "England v Equador",
    "season": "2005/06"
  },
  {
    "num": "46",
    "x": "63",
    "y": "352",
    "x2": "300",
    "y2": "450",
    "x3": "387",
    "y3": "565",
    "curve": "0.55",
    "club": "Real Madrid",
    "fixture": "Sevilla v Real Madrid",
    "season": "2006/07"
  },
  {
    "num": "47",
    "x": "470",
    "y": "255",
    "x2": "450",
    "y2": "450",
    "x3": "322",
    "y3": "550",
    "curve": "0.35",
    "club": "Real Madrid",
    "fixture": "Real Sociedad v Real Madrid",
    "season": "2006/07"
  },
  {
    "num": "48",
    "x": "405",
    "y": "305",
    "x2": "450",
    "y2": "480",
    "x3": "322",
    "y3": "560",
    "curve": "0.35",
    "club": "LA Galaxy",
    "fixture": "LA Galaxy v DC United",
    "season": "2007/08"
  },
  {
    "num": "49",
    "x": "368",
    "y": "255",
    "x2": "470",
    "y2": "450",
    "x3": "320",
    "y3": "562",
    "curve": "0.35",
    "club": "LA Galaxy",
    "fixture": "LA Galaxy v Real Salt Lake",
    "season": "2007/08"
  },
  {
    "num": "50",
    "x": "120",
    "y": "460",
    "x2": "250",
    "y2": "510",
    "x3": "325",
    "y3": "560",
    "curve": "2",
    "club": "AC Milan",
    "fixture": "AC Milan v Genoa",
    "season": "2008/09"
  },
  {
    "num": "51",
    "x": "302",
    "y": "320",
    "x2": "400",
    "y2": "480",
    "x3": "375",
    "y3": "562",
    "curve": "0.65",
    "club": "LA Galaxy",
    "fixture": "LA Galaxy v Chivas USA",
    "season": "2010"
  },
  {
    "num": "52",
    "x": "121",
    "y": "320",
    "x2": "350",
    "y2": "480",
    "x3": "330",
    "y3": "562",
    "curve": "0.55",
    "club": "LA Galaxy",
    "fixture": "LA Galaxy v Sporting Kansas",
    "season": "2011"
  },
  {
    "num": "53",
    "x": "529",
    "y": "325",
    "x2": "500",
    "y2": "500",
    "x3": "375",
    "y3": "562",
    "curve": "0.35",
    "club": "LA Galaxy",
    "fixture": "Montreal v LA Galaxy",
    "season": "2012"
  },
  {
    "num": "54",
    "x": "270",
    "y": "355",
    "x2": "400",
    "y2": "500",
    "x3": "335",
    "y3": "562",
    "curve": "0.15",
    "club": "LA Galaxy",
    "fixture": "San Jose v LA Galaxy",
    "season": "2012"
  },
  {
    "num": "55",
    "x": "240",
    "y": "325",
    "x2": "350",
    "y2": "480",
    "x3": "322",
    "y3": "552",
    "curve": "0.55",
    "club": "LA Galaxy",
    "fixture": "Portland v LA Galaxy",
    "season": "2012"
  },
  {
    "num": "56",
    "x": "290",
    "y": "335",
    "x2": "365",
    "y2": "480",
    "x3": "327",
    "y3": "562",
    "curve": "0.55",
    "club": "LA Galaxy",
    "fixture": "LA Galaxy v Vancouver",
    "season": "2012"
  }
]